import React, { useEffect, useReducer, useState } from 'react';
import {
  Pagination,
  Popconfirm,
  Select,
  Table,
  Tabs,
  Row,
  Col,
  Typography,
  Space,
  notification,
  Badge,
  Modal,
  Layout,
} from 'antd';
import { Link } from 'react-router-dom';

import MESSAGES from '../../enums/Messages';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import CustomButton from '../../components/CustomButton';
import SpinLoad from '../../components/SpinLoad';

import { filter as filterStatus } from '../../api/module/status_process';
import {
  filter as filterSVDP,
  patch as patchSVDP,
  getProjects,
  getRoles,
  getTerms,
  getCounters,
} from '../../api/module/term_document_contract_validation';

import './style.scss';
import CustomSelector from '../../components/CustomSelector';
import { AjaxTable } from '../../components';
import { ClockCircleOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;
const { Content } = Layout;

const breadcrumbItems = [
  {
    text: 'Seguimiento Validación Documentación Parcial',
  },
];

const initSelectors = {
  proyecto: undefined,
  cargo: undefined,
  identificador: undefined,
  firstLoad: true,
};

const initCounters = () => ({
  review: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  incomplete: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
  approved: (
    <ClockCircleOutlined style={{ marginLeft: '13px', marginRight: '3px' }} />
  ),
});

function reducer(state, action) {
  switch (action.type) {
    case 'project':
      return { ...initSelectors, proyecto: action.payload, firstLoad: false };
    case 'project_init':
      if (state.firstLoad)
        return {
          ...initSelectors,
          proyecto: action.payload?.value,
          firstLoad: false,
        };
      return state;
    case 'role':
      return {
        ...state,
        cargo: action.payload?.value,
        experiencia_requerida: action.payload?.experiencia_requerida,
        educacion_requerida: action.payload?.educacion_requerida,
        identificador: initSelectors.identificador,
        firstLoad: false,
      };
    case 'role_init':
      if (state.firstLoad)
        return {
          proyecto: action.payload?.proyecto,
          cargo: action.payload?.value,
          experiencia_requerida: action.payload?.experiencia_requerida,
          educacion_requerida: action.payload?.educacion_requerida,
          identificador: initSelectors.identificador,
          firstLoad: false,
        };
      return state;
    case 'term':
      return { ...state, identificador: action.payload, firstLoad: false };
    case 'term_init':
      if (state.firstLoad)
        return {
          proyecto: action.payload.proyecto,
          cargo: action.payload.cargo,
          experiencia_requerida: action.payload?.experiencia_requerida,
          educacion_requerida: action.payload?.educacion_requerida,
          identificador: action.payload.value,
          firstLoad: false,
        };
      return state;
    default:
      return initSelectors;
  }
}

function DocumentValidationPartialHomeSelectors({ match, setQuery }) {
  const [state, dispatch] = useReducer(reducer, initSelectors);

  useEffect(() => {
    if (!match.params.type || Object.values(state).some((value) => !!value)) {
      let q = '';
      if (q === '' && state.identificador) {
        q = `filter[termino]=${state.identificador}`;
      }
      if (q === '' && state.cargo) {
        q = `filter[cargo]=${state.cargo}`;
      }
      if (q === '' && state.proyecto) {
        q = `filter[proyecto]=${state.proyecto}`;
      }
      setQuery({
        query: q,
        param: {
          proyecto: state.proyecto,
          cargo: state.cargo,
          termino: state.identificador,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <div className="box-description" key="vdc-selectors">
      {(!match.params.type ||
        (match.params.type === 'project' && state.firstLoad) ||
        state.proyecto) && (
        <Row className="box-selectors">
          <Col span={6}>
            <Title level={4}>Proyecto a revisar:</Title>
          </Col>
          <Col span={17} offset={0.5}>
            <CustomSelector
              onChange={(value) =>
                dispatch({ type: 'project', payload: value })
              }
              initialValue={
                match.params.type && match.params.type === 'project'
                  ? parseInt(match.params.id)
                  : state.proyecto
              }
              onLoad={(values) => {
                if (match.params.type === 'project' && values?.value)
                  dispatch({
                    type: 'project_init',
                    payload: values,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder: 'Seleccione el proyecto a revisar...',
              }}
              endpointFetch={async () => {
                return await getProjects();
              }}
              key={match.url}
            />
          </Col>
        </Row>
      )}
      {(state.proyecto ||
        (match.params.type === 'role' && state.firstLoad)) && (
        <Row className="box-selectors">
          <Col span={6}>
            <Title level={4}>Cargo/rol a revisar:</Title>
          </Col>
          <Col span={17} offset={0.5}>
            <CustomSelector
              onChangeData={(values) =>
                dispatch({ type: 'role', payload: values })
              }
              initialValue={
                match.params.type && match.params.type === 'role'
                  ? parseInt(match.params.id)
                  : state.cargo
              }
              onLoad={(values) => {
                if (match.params.type === 'role' && values?.value)
                  dispatch({
                    type: 'role_init',
                    payload: values,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder: 'Seleccione el Cargo / Rol a revisar... ',
              }}
              endpointFetch={async () => {
                return await getRoles({
                  'filter[proyecto]': state.proyecto,
                });
              }}
              key={`rs-${state.proyecto}`}
            />
          </Col>
        </Row>
      )}
      {(state.cargo || (match.params.type === 'term' && state.firstLoad)) && (
        <Row className="box-selectors" align="middle">
          <Col span={6}>
            <Title level={4} style={{ paddingRight: '15px' }}>
              Identificador del término a revisar:
            </Title>
          </Col>
          <Col span={17} offset={0.5}>
            <CustomSelector
              onChange={(value) => dispatch({ type: 'term', payload: value })}
              initialValue={
                match.params.type && match.params.type === 'term'
                  ? parseInt(match.params.id)
                  : state.identificador
              }
              onLoad={(values) => {
                if (match.params.type === 'term' && values?.value)
                  dispatch({
                    type: 'term_init',
                    payload: values,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder:
                  'Seleccione el identificador único del termino de referencia... ',
              }}
              endpointFetch={async () => {
                return await getTerms({
                  'filter[cargo]': state.cargo,
                });
              }}
              key={`rs-${state.cargo}`}
            />
          </Col>
        </Row>
      )}
      {/* {state.educacion_requerida && (
        <Descriptions layout="vertical" column={1} bordered>
          <Descriptions.Item label={'Requerimientos de educación / formación'}>
            {state.educacion_requerida}
          </Descriptions.Item>
          <Descriptions.Item label={'Requerimientos de experiencia'}>
            {state.experiencia_requerida}
          </Descriptions.Item>
        </Descriptions>
      )} */}
    </div>
  );
}

const DocumentValidationPartialHome = ({ match }) => {
  const [query, setQuery] = useState({});

  const [counters, setCounters] = useState(initCounters);
  const [stateOpt, setStateOpt] = useState([]);

  const [acceptableSubs, setAcceptableSubs] = useState([]);

  const [activeTab, setActiveTab] = useState('review');

  async function fetchCounters() {
    setCounters(initCounters);
    const { data: cData } = await getCounters(query.param);
    setCounters(cData.results);
  }

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await filterStatus('/?filter[sigla.icontains]=TDR-SVDP-G-');
        const resSub = await filterStatus(
          '/?filter[sigla.icontains]=TDR-SVDP-M-',
        );
        const states = res.data.results.map((x) => {
          return { label: x.nombre, value: x.id, sigla: x.sigla };
        });
        const subStates = resSub.data.results.reduce((prev, x) => {
          prev[x.sigla] = x.id;
          return prev;
        }, {});
        setStateOpt(states);

        setAcceptableSubs(subStates);
      } catch (err) {
        console.log(err);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_GET_MSG,
          duration: 2,
        });
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (query.query) fetchCounters();
  }, [query.query]);

  const onStatusSave = (id, newState) => {
    async function putStatus(id, newState) {
      try {
        await patchSVDP(id, { estado_validacion_general: newState.value });
        setActiveTab(newState.sigla);
      } catch (err) {
        console.log(err);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_POST_MSG,
          duration: 2,
        });
      }
    }
    putStatus(id, newState);
    fetchCounters();
  };

  const columns = [
    {
      title: 'Tipo persona',
      dataIndex: ['tercero', 'tipo_persona_nombre'],
      fixed: true,
    },
    {
      title: 'Nombre completo/Razón social',
      dataIndex: ['tercero', 'nombre_completo'],
      fixed: true,
    },
    {
      title: 'Tipo doc',
      dataIndex: ['tercero', 'tipo_identificacion_sigla'],
    },
    {
      title: 'Nro. Documento',
      dataIndex: ['tercero', 'numero_identificacion'],
    },
    {
      title: 'Teléfono',
      dataIndex: ['tercero', 'numero_celular'],
    },
    {
      title: 'Correo Electrónico',
      dataIndex: ['tercero', 'notificacion_email'],
    },
  ];

  const extraColumnsToCheck = [
    {
      title: 'Validar Documentos',
      key: 'validate_button',
      render: (_, record) => (
        <CustomButton
          block
          type="primary"
          htmlType={'button'}
          text={
            <Link
              to={`${INTERNAL_LINKS.DOCUMENT_VALIDATION_PARTIAL}-validar/${record.id}`}
            >
              Validar
            </Link>
          }
        />
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => {
        let thisStates;
        if (record.tercero.tipo_persona_nombre === 'Natural')
          thisStates = [
            record.estado_validacion_basicos,
            record.estado_validacion_formacion,
            record.estado_validacion_experiencia,
            record.estado_validacion_icfes,
          ];
        else thisStates = [record.estado_validacion_basicos];
        return (
          <StateSelector
            // defState={record.estado_validacion_general}
            thisStates={thisStates}
            subStates={acceptableSubs}
            onSave={(newStatus) => onStatusSave(record.id, newStatus)}
            options={stateOpt}
          />
        );
      },
    },
  ];

  const extraColumnsAdjust = [
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => (
        <>
          <CustomButton
            block
            type={'default'}
            htmlType={'button'}
            className={'ant-btn-info'}
            text={
              <Link
                to={`${INTERNAL_LINKS.DOCUMENT_VALIDATION_PARTIAL_EMAIL}/${record.id}`}
              >
                Generar Correo
              </Link>
            }
          />
          {record.estado_envio && 'Enviado'}
        </>
      ),
    },
    {
      title: 'Historial de correos',
      key: 'datetime',
      render: (_, record) => (
        <CustomButton
          block
          type={'default'}
          htmlType={'button'}
          text={
            <Link
              to={`${INTERNAL_LINKS.DOCUMENT_VALIDATION_PARTIAL_EMAIL_HISTORY}/${record.id}`}
              target="_blank"
            >
              Historial
            </Link>
          }
        />
      ),
    },
  ];

  const extraColumnsApproved = [
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => (
        <CustomButton
          block
          type={'default'}
          htmlType={'button'}
          className={'ant-btn-info'}
          text={
            <Link
              to={`${INTERNAL_LINKS.DOCUMENT_VALIDATION_PARTIAL}-validar/${record.id}`}
            >
              Ver
            </Link>
          }
        />
      ),
    },
  ];

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Seguimiento Validación Documentación Parcial
      </Title>
      <DocumentValidationPartialHomeSelectors
        match={match}
        setQuery={setQuery}
      />
      {query.query && (
        <>
          <div className="box-table">
            <Tabs
              defaultActiveKey={'review'}
              activeKey={activeTab}
              onTabClick={(key, _) => {
                setActiveTab(key);
              }}
              destroyInactiveTabPane={true}
              type="card"
              key={query.query}
            >
              <TabPane
                tab={
                  <Paragraph>
                    Aprobados parciales
                    <Badge showZero count={counters.review} />
                  </Paragraph>
                }
                key="review"
              >
                <AjaxTable
                  tableTitle="Listado de Contratistas"
                  columns={[...columns, ...extraColumnsToCheck]}
                  query={{
                    ...query.param,
                    estado_validacion_general__isnull: true,
                  }}
                  endpoint={filterSVDP}
                  searchInput
                  reloadButton
                  onReload={fetchCounters}
                />
              </TabPane>
              <TabPane
                tab={
                  <Paragraph>
                    Ajustar información
                    <Badge showZero count={counters.incomplete} />
                  </Paragraph>
                }
                key="TDR-SVDP-G-AI"
              >
                <AjaxTable
                  tableTitle="Listado de Contratistas"
                  columns={[...columns, ...extraColumnsAdjust]}
                  query={{
                    ...query.param,
                    estado_validacion_general__sigla: 'TDR-SVDP-G-AI',
                  }}
                  endpoint={filterSVDP}
                  searchInput
                  reloadButton
                  onReload={fetchCounters}
                />
              </TabPane>
              <TabPane
                tab={
                  <Paragraph>
                    Aprobados completos
                    <Badge showZero count={counters.approved} />
                  </Paragraph>
                }
                key="TDR-SVDP-G-AC"
              >
                <AjaxTable
                  tableTitle="Listado de Contratistas"
                  columns={[...columns, ...extraColumnsApproved]}
                  query={{
                    ...query.param,
                    estado_validacion_general__sigla: 'TDR-SVDP-G-AC',
                  }}
                  endpoint={filterSVDP}
                  searchInput
                  reloadButton
                  onReload={fetchCounters}
                />
              </TabPane>
            </Tabs>
          </div>
        </>
      )}
    </Content>
  );
};

const StateSelector = ({
  defState = undefined,
  onSave = () => {},
  options = [],
  thisStates = undefined,
  subStates = undefined,
}) => {
  const [state, setState] = useState(defState);

  function onSelfSave() {
    const selectedS = options.find((x) => x.value === state);
    const anyEmpty = thisStates.some((x) => !x);
    const fullyAcceptable = thisStates.every(
      (x) => subStates['TDR-SVDP-M-AC'] === x,
    );
    const onlyAJ = thisStates.some((x) => x === subStates['TDR-SVDP-M-AI']);
    if (!fullyAcceptable && selectedS.sigla === 'TDR-SVDP-G-AC') {
      Modal.warning({
        title: 'Estado inválido',
        content: 'El registro tiene estados diferentes a Aprobado completo.',
      });
      return;
    }
    if (fullyAcceptable && selectedS.sigla !== 'TDR-SVDP-G-AC') {
      Modal.warning({
        title: 'Estado inválido',
        content:
          'El registro tiene todos sus estados en Aprobado completo, solo se puede guardar `Aprobado completo`',
      });
      return;
    }
    if (onlyAJ && selectedS.sigla !== 'TDR-SVDP-G-AI') {
      Modal.warning({
        title: 'Estado inválido',
        content:
          'El registro tiene estados en Ajustar Información, solo se puede guardar `Devolver`',
      });
      return;
    }
    if (anyEmpty) {
      Modal.confirm({
        title: 'Estado inválido',
        content: 'Hay módulos sin estado. ¿Desea continuar?',
        okText: 'Si',
        cancelText: 'No',
        onOk: () => onSave(selectedS),
      });
      return;
    }
    onSave(selectedS);
  }

  return (
    <Space direction="horizontal">
      <Select
        onChange={setState}
        defaultValue={defState}
        placeholder="Seleccione el estado..."
        options={options}
      />
      <Popconfirm
        onConfirm={() => {
          onSelfSave();
        }}
        title={MESSAGES.MSG_SAVE_STATE}
      >
        <CustomButton type="default" text="Guardar" disabled={!state} />
      </Popconfirm>
    </Space>
  );
};

export default DocumentValidationPartialHome;
